'use strict';

function introRouting($stateProvider) {

    let introBaseState = 'root.debug';

    $stateProvider

    /**
     * WITHOUT END-POINT Section - Debug
     */
        .state('' + introBaseState + '', {
            abstract: true,
            url: "/debug",
            views: {
                '': {
                    template: "<ui-view/>",
                },
                'sidebar@root': {
                    template: require("./navigation.html")
                }
            },
            resolve: {
                loadSectionSpecific: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('./debug.section-specific.js');
                            $ocLazyLoad.load({name: module.name});
                            resolve(module);
                        })
                    });
                },
                loadClerkLedgerDeliverableCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-deliverable/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-deliverable")
                    });
                },
            },
            data: {
                baseState: introBaseState,
                requiresLogin: true,
                pageTitle: 'Debug',
                showSideMenu: true
            }
        })

        .state('' + introBaseState + '.overview', {
            url: "/overview",
            template: require("./overview.html"),
            data: {
                pageTitle: 'Debug'
            }
        });

};

function routing($stateProvider) {

    let baseState = 'root.api-endpoints.existing.debug';

    $stateProvider

    /**
     * Section - Debug
     */
        .state('' + baseState + '', {
            abstract: true,
            url: "/debug",
            views: {
                '': {
                    template: "<ui-view/>",
                },
                'sidebar@root': {
                    template: require("./navigation.html")
                }
            },
            resolve: {
                setRouteBasedVisibilitySettingsLevel0: /*@ngInject*/ function (routeBasedVisibilitySettings, $stateParams) {
                    /*
                     routeBasedVisibilitySettings.SuggestedAction_columns_by_step = 'debug';
                     routeBasedVisibilitySettings.ImportSession_columns_by_step = 'import-debug';
                     routeBasedVisibilitySettings.ImportSessionManyManyFiles_columns_by_step = 'import-debug';
                     routeBasedVisibilitySettings.InputResult_columns_by_step = 'import-debug';
                     routeBasedVisibilitySettings.ClerkInputResultMetadata_columns_by_step = 'import-debug';
                     */
                },
                setRouteBasedContentFiltersLevel1: /*@ngInject*/ function (setRouteBasedContentFiltersLevel0, routeBasedContentFilters, $stateParams) {
                    // Make these reset to empty by default in this section unless otherwise specified
                    routeBasedContentFilters.ClerkDeliverable_section_scope = null;
                    routeBasedContentFilters.ClerkLedgerDeliverable_ClerkDeliverable_section_scope = null;
                    routeBasedContentFilters.ClerkFiscalYear_ClerkTaxEntity_ClerkTaxEntityType_ref = null;
                    routeBasedContentFilters.ClerkLedger_ClerkTaxEntity_ClerkTaxEntityType_ref = null;
                    routeBasedContentFilters.ClerkTaxEntity_ClerkTaxEntityType_ref = null;
                    routeBasedContentFilters.ClerkTaxEntity_knowledge_of_internals_expected = null;
                },
                loadSectionSpecific: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('./debug.section-specific.js');
                            $ocLazyLoad.load({name: module.name});
                            resolve(module);
                        })
                    });
                },
                loadSqMerchantCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/sq-merchant/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-sq-merchant")
                    });
                },
                loadSqInboxQueryTemplateCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/sq-inbox-query-template/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-sq-inbox-query-template")
                    });
                },
                loadActivityCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/activity/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-activity")
                    });
                },
                loadActivityMappingCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/activity-mapping/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-activity-mapping")
                    });
                },
                loadClueCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clue/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clue")
                    });
                },
                loadDataPointCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/data-point/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-data-point")
                    });
                },
                loadDataPointMappingCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/data-point-mapping/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-data-point-mapping")
                    });
                },
                loadDenormalizedInterpretationCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/denormalized-interpretation/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-denormalized-interpretation")
                    });
                },
                loadEntityCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/entity/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-entity")
                    });
                },
                loadEntityMappingCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/entity-mapping/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-entity-mapping")
                    });
                },
                loadInputCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/input/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-input")
                    });
                },
                loadInputAccessTypeCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/input-access-type/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-input-access-type")
                    });
                },
                loadInputAccessTypeConfigurationCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/input-access-type-configuration/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-input-access-type-configuration")
                    });
                },
                loadInputContentTypeCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/input-content-type/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-input-content-type")
                    });
                },
                loadInputHasInputAccessTypeConfigurationCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/input-has-input-access-type-configuration/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-input-has-input-access-type-configuration")
                    });
                },
                loadInputResultCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/input-result/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-input-result")
                    });
                },
                loadInterpretationCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/interpretation/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-interpretation")
                    });
                },
                loadInterpreterCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/interpreter/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-interpreter")
                    });
                },
                loadLocationCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/location/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-location")
                    });
                },
                loadLocationMappingCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/location-mapping/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-location-mapping")
                    });
                },
                loadOutputAccessTypeCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/output-access-type/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-output-access-type")
                    });
                },
                loadOutputContentTypeCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/output-content-type/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-output-content-type")
                    });
                },
                loadOutputResultCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/output-result/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-output-result")
                    });
                },
                loadQuantaCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/quanta/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-quanta")
                    });
                },
                loadQuantaMappingCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/quanta-mapping/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-quanta-mapping")
                    });
                },
                loadTimeSlotTypeCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/time-slot-type/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-time-slot-type")
                    });
                },
                loadInboxQueryCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/inbox-query/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-inbox-query")
                    });
                },
                loadInboxQueryResponseCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/inbox-query-response/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-inbox-query-response")
                    });
                },
                loadWhereaboutCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/whereabout/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-whereabout")
                    });
                },
                loadIndicatedEntityWhereaboutPresenceCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/indicated-entity-whereabout-presence/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-indicated-entity-whereabout-presence")
                    });
                },
                loadImportSessionCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/import-session/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-import-session")
                    });
                },
                loadImportSessionManyManyFileCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/import-session-many-many-file/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-import-session-many-many-file")
                    });
                },
                loadNeamtimeClientCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/neamtime-client/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-neamtime-client")
                    });
                },
                loadNeamtimeClientCostPoolCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/neamtime-client-cost-pool/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-neamtime-client-cost-pool")
                    });
                },
                loadNeamtimeInvoiceCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/neamtime-invoice/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-neamtime-invoice")
                    });
                },
                loadNeamtimeInvoiceTimesheetCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/neamtime-invoice-timesheet/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-neamtime-invoice-timesheet")
                    });
                },
                loadNeamtimeInvoicedTimeCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/neamtime-invoiced-time/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-neamtime-invoiced-time")
                    });
                },
                loadNeamtimeProjectCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/neamtime-project/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-neamtime-project")
                    });
                },
                loadNeamtimeSignificantActivityCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/neamtime-significant-activity/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-neamtime-significant-activity")
                    });
                },
                loadNeamtimeSignificantActivityMappingCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/neamtime-significant-activity-mapping/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-neamtime-significant-activity-mapping")
                    });
                },
                loadNeamtimeSignificantActivityMappingGraphCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/neamtime-significant-activity-mapping-graph/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-neamtime-significant-activity-mapping-graph")
                    });
                },
                loadNeamtimeSignificantPeriodCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/neamtime-significant-period/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-neamtime-significant-period")
                    });
                },
                loadNeamtimeSignificantTimeInterpretationCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/neamtime-significant-time-interpretation/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-neamtime-significant-time-interpretation")
                    });
                },
                loadNeamtimeTimeSpentInterpretationCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/neamtime-time-spent-interpretation/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-neamtime-time-spent-interpretation")
                    });
                },
                loadNeamtimeDatasetCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/neamtime-dataset/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-neamtime-dataset")
                    });
                },
                loadNeamtimeDrillDownDimensionCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/neamtime-drill-down-dimension/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-neamtime-drill-down-dimension")
                    });
                },
                loadNeamtimeClientCostPoolDistributionCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/neamtime-client-cost-pool-distribution/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-neamtime-client-cost-pool-distribution")
                    });
                },
                loadDenormalizedNeamtimeInvoicedTimeCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/denormalized-neamtime-invoiced-time/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-denormalized-neamtime-invoiced-time")
                    });
                },
                loadNeamtimeActuallyDoneSpecificationCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/neamtime-actually-done-specification/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-neamtime-actually-done-specification")
                    });
                },
                loadNeamtimeSupposedToBeDoneSpecificationCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/neamtime-supposed-to-be-done-specification/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-neamtime-supposed-to-be-done-specification")
                    });
                },
                loadNeamtimeProcessCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/neamtime-process/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-neamtime-process")
                    });
                },
                loadNeamtimeInputResultMetadataCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/neamtime-input-result-metadata/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-neamtime-input-result-metadata")
                    });
                },
                loadClerkAmbitionLevelCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ambition-level/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ambition-level")
                    });
                },
                loadClerkLedgerEntryCategoryCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-entry-category/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-entry-category")
                    });
                },
                loadClerkPersonalVsBusinessScenarioCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-personal-vs-business-scenario/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-personal-vs-business-scenario")
                    });
                },
                loadClerkCurrencyCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-currency/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-currency")
                    });
                },
                loadClerkInvoiceItemCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-invoice-item/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-invoice-item")
                    });
                },
                loadClerkInvoiceRowCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-invoice-row/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-invoice-row")
                    });
                },
                loadClerkInOutNeitherCategoryCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-in-out-neither-category/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-in-out-neither-category")
                    });
                },
                loadClerkFinancialEventCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-financial-event/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-financial-event")
                    });
                },
                loadClerkTaxEntityEmailIdentityCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-tax-entity-email-identity/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-tax-entity-email-identity")
                    });
                },
                loadClerkReportingBasisCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-reporting-basis/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-reporting-basis")
                    });
                },
                loadClerkMerchantSourceAttributeMappingCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-merchant-source-attribute-mapping/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-merchant-source-attribute-mapping")
                    });
                },
                loadClerkFinancialEventIntermediate1Crud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-financial-event-intermediate1/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-financial-event-intermediate1")
                    });
                },
                loadClerkAccountCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-account/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-account")
                    });
                },
                loadClerkAccountCategoryCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-account-category/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-account-category")
                    });
                },
                loadClerkTaxEntityTypeCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-tax-entity-type/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-tax-entity-type")
                    });
                },
                loadClerkTransactionCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-transaction/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-transaction")
                    });
                },
                loadClerkTransactionRowCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-transaction-row/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-transaction-row")
                    });
                },
                loadClerkVatScenarioCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-vat-scenario/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-vat-scenario")
                    });
                },
                loadClerkDatasetCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-dataset/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-dataset")
                    });
                },
                loadClerkTravelClaimCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-travel-claim/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-travel-claim")
                    });
                },
                loadClerkTripCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-trip/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-trip")
                    });
                },
                loadClerkSignificantPeriodCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-significant-period/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-significant-period")
                    });
                },
                loadClerkFiscalYearCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-fiscal-year/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-fiscal-year")
                    });
                },
                loadClerkAccountBalanceCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-account-balance/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-account-balance")
                    });
                },
                loadClerkTaxEntityCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-tax-entity/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-tax-entity")
                    });
                },
                loadClerkLedgerAccountCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-account/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-account")
                    });
                },
                loadClerkTaxRegionCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-tax-region/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-tax-region")
                    });
                },
                loadClerkLedgerAccountBalanceCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-account-balance/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-account-balance")
                    });
                },
                loadClerkLedgerAccountTypeCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-account-type/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-account-type")
                    });
                },
                loadClerkLedgerEntryCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-entry/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-entry")
                    });
                },
                loadClerkLedgerAccountRoleCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-account-role/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-account-role")
                    });
                },
                loadClerkLedgerEntryRowCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-entry-row/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-entry-row")
                    });
                },
                loadClerkLedgerEntryTypeCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-entry-type/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-entry-type")
                    });
                },
                loadClerkInvoiceCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-invoice/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-invoice")
                    });
                },
                loadClerkBasisOfAccountingCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-basis-of-accounting/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-basis-of-accounting")
                    });
                },
                loadClerkTransactionTypeCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-transaction-type/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-transaction-type")
                    });
                },
                loadClerkTypeOfExchangeCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-type-of-exchange/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-type-of-exchange")
                    });
                },
                loadClerkLedgerCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger")
                    });
                },
                loadClerkDeliverableCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-deliverable/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-deliverable")
                    });
                },
                loadClerkDeliverableArtifactCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-deliverable-artifact/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-deliverable-artifact")
                    });
                },
                loadClerkLedgerDeliverableCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-deliverable/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-deliverable")
                    });
                },
                loadClerkLedgerDeliverableArtifactCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-ledger-deliverable-artifact/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-ledger-deliverable-artifact")
                    });
                },
                loadClerkTaxEntityRelationCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-tax-entity-relation/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-tax-entity-relation")
                    });
                },
                loadClerkTaxEntityRelationTypeCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-tax-entity-relation-type/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-tax-entity-relation-type")
                    });
                },
                loadClerkSupportingDocumentCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-supporting-document/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-supporting-document")
                    });
                },
                loadClerkSupportingDocumentTypeCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-supporting-document-type/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-supporting-document-type")
                    });
                },
                loadClerkInputResultMetadataCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/clerk-input-result-metadata/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-clerk-input-result-metadata")
                    });
                },
                loadSuggestedActionCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/suggested-action/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-suggested-action")
                    });
                },
                loadAccountCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/account/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-account")
                    });
                },
                loadNodeCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/node/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-node")
                    });
                },
                loadEdgeCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/edge/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-edge")
                    });
                },
                loadFileCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/file/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-file")
                    });
                },
                loadFileInstanceCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/file-instance/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-file-instance")
                    });
                },
                loadAuth0UserCrud: /*@ngInject*/ ($q, $ocLazyLoad) => {
                    return $q((resolve) => {
                        require.ensure([], () => {
                            let module = require('crud/auth0-user/components.js');
                            $ocLazyLoad.load({name: module.default.name});
                            resolve(module);
                        }, "crud-auth0-user")
                    });
                },
            },
            data: {
                baseState: baseState,
                pageTitle: 'Supply debug',
                showSideMenu: true
            }
        })

        .state('' + baseState + '.overview', {
            url: "/overview",
            template: require("./overview.html"),
            data: {
                pageTitle: 'Debug',
                showSideMenu: false
            }
        })

        .state('' + baseState + '.files', {
            url: "/files",
            template: require("./files.html"),
            data: {pageTitle: 'Debug'}
        })

        .state('' + baseState + '.interpretation-of-raw-data', {
            url: "/interpretation-of-raw-data",
            template: require("./interpretation-of-raw-data.html"),
            data: {pageTitle: 'Debug'}
        })

        .state('' + baseState + '.import-queue', {
            url: "/import-queue",
            template: require("./import-queue.html"),
            resolve: {
                setRouteBasedContentFiltersLevel2: /*@ngInject*/ function (setRouteBasedContentFiltersLevel1, routeBasedContentFilters, $stateParams) {
                    //routeBasedContentFilters.ImportSession_not_yet_import_processed = 1; // Don't filter on is since we may want to open and close import sessions for import processing in the debug views
                    routeBasedContentFilters.ImportSessionManyManyFile_not_yet_import_processed = 1;
                    routeBasedContentFilters.InputResult_not_yet_import_processed = 1;
                    routeBasedContentFilters.ClerkInputResultMetadata_InputResult_not_yet_import_processed = 1;
                    routeBasedContentFilters.NeamtimeInputResultMetadata_InputResult_not_yet_import_processed = 1;
                    routeBasedContentFilters.Clue_not_yet_import_processed = 1;
                    routeBasedContentFilters.Interpretation_not_yet_import_processed = 1;
                },
            },
            data: {pageTitle: 'Debug'}
        })

        .state('' + baseState + '.shared-application-data-clerk', {
            url: "/shared-application-data-clerk",
            template: require("./shared-application-data-clerk.html"),
            resolve: {
                setRouteBasedContentFiltersLevel2: /*@ngInject*/ function (setRouteBasedContentFiltersLevel1, routeBasedContentFilters, $stateParams) {
                    routeBasedContentFilters.ClerkLedgerEntryCategory_order = 'ordinal ASC';
                    routeBasedContentFilters.ClerkLedgerEntryType_order = 'relevant_clerk_ledger_entry_category_id ASC';
                    return true;
                },
            },
            data: {pageTitle: 'Debug'}
        })

        .state('' + baseState + '.shared-application-data-sq', {
            url: "/shared-application-data-sq",
            template: require("./shared-application-data-sq.html"),
            data: {pageTitle: 'Debug'}
        })

        .state('' + baseState + '.tax-entities-fiscal-years-and-ledgers', {
            url: "/tax-entities-fiscal-years-and-ledgers",
            template: require("./tax-entities-fiscal-years-and-ledgers.html"),
            data: {pageTitle: 'Debug'}
        });

}

export default angular
    .module('debug.routing', [])
    .config(function ($stateProvider) {

        // Lazy load the states instead of loading them all at app bootstrap

        /*
         let lazyIntroStateProvider = {
         states: [],
         state: function (name, stateConfig) {
         let state = angular.merge({name: name}, stateConfig);
         this.states.push(state);
         return this;
         }
         };
         introRouting(lazyIntroStateProvider);
         $stateProvider.state('root.debug.**', {
         url: "/debug",
         lazyLoad: function ($transition$, ParentService) {
         return lazyIntroStateProvider;
         },
         });
         */
        // Eager-loading intro-states since there are issues with those routes and since they are so few, it is ok to load them eagerly for now
        introRouting($stateProvider);

        let lazyStateProvider = {
            states: [],
            state: function (name, stateConfig) {
                let state = angular.merge({name: name}, stateConfig);
                this.states.push(state);
                return this;
            }
        };
        routing(lazyStateProvider);
        $stateProvider.state('root.api-endpoints.existing.debug.**', {
            url: "/debug",
            lazyLoad: function ($transition$, ParentService) {
                return lazyStateProvider;
            },
        });

    });



// WEBPACK FOOTER //
// .-dna/app/sections/debug/debug.routing.js